module.exports = __webpack_public_path__ + "img/icon_02@2x.085cf114.png";